<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari judul background&hellip;"
                 aria-label="Cari background" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <div class="vl-spacer"></div>
          <button type="button" class="vl-btn-primary" (click)="onShowAdd()"
                  data-bs-toggle="modal" data-bs-target="#formData">+ Buat Background</button>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Gambar</th>
                  <th>Judul</th>
                  <th class="text-right">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let v of isData; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
                  <th class="vl-num">{{rowNo(i)}}</th>
                  <td>
                    <img *ngIf="v.image_url" [src]="v.image_url" alt="{{v.name}}" class="vb-thumb vb-click"
                         title="Lihat ukuran penuh" (click)="openViewer(v.image_url)">
                    <span *ngIf="!v.image_url" class="vl-muted">&mdash;</span>
                  </td>
                  <td><span class="vl-name" [innerHTML]="highlight(v.name)"></span></td>
                  <td>
                    <div class="vl-actions">
                      <button type="button" class="vl-icon" title="Edit" (click)="onEdit(v)" data-bs-toggle="modal"
                              data-bs-target="#formData"><i class="fa fa-edit"></i></button>
                      <button type="button" class="vl-icon danger" title="Hapus" (click)="onDelete(v)"><i class="fa fa-trash"></i></button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="!isData.length">
                  <td colspan="4" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> background</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- FORM -->
<form [formGroup]="isForm" (ngSubmit)="onSubmit()">
  <div class="modal fade" id="formData" aria-labelledby="formDataLabel" aria-hidden="true" data-keyboard="false"
       data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header vf-header">
          <div>
            <h6 class="modal-title vf-title" id="formDataLabel">{{isForm.value.id ? 'Edit background' : 'Buat background'}}</h6>
            <div class="vf-subtitle">{{isForm.value.id ? 'Perbarui judul atau ganti desain background ini.' : 'Unggah desain background untuk kartu voucher.'}}</div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" [disabled]="isLoading"></button>
        </div>
        <div class="modal-body">
          <div class="vf-grid">
            <div class="vf-field full">
              <label class="vf-label">Judul <span class="req">*</span></label>
              <input type="text" class="vf-input" [class.invalid]="isInvalid('name')"
                     placeholder="Judul background, misal: Desain Ramadhan" formControlName="name">
              <div class="vf-error" *ngIf="isInvalid('name')">Judul wajib diisi.</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">Gambar <span class="req" *ngIf="!isForm.value.id">*</span></label>
              <input class="vf-input vf-file" type="file" accept="image/*" [class.invalid]="isInvalid('images')"
                     formControlName="images" (change)="onFileSelect($event)">
              <div class="vf-hint" *ngIf="isForm.value.id && !isPreview">Biarkan kosong jika desain tidak diganti.</div>
              <div class="vf-error" *ngIf="isInvalid('images')">Gambar wajib diunggah.</div>
            </div>
            <div class="vf-field full" *ngIf="isPreview || isCurrentImage">
              <label class="vf-label">{{isPreview ? 'Pratinjau desain baru' : 'Desain saat ini'}}</label>
              <img [src]="isPreview || isCurrentImage" alt="Pratinjau background" class="vf-preview vb-click"
                   title="Lihat ukuran penuh" (click)="openViewer(isPreview || isCurrentImage)">
            </div>
          </div>
        </div>
        <div class="modal-footer vf-footer">
          <button type="button" class="vl-btn-ghost" data-bs-dismiss="modal" [disabled]="isLoading">Batal</button>
          <button type="submit" class="vl-btn-primary" [disabled]="isLoading">
            <i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i> Simpan</button>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- delete confirmation dialog (custom, design-system styled) -->
<div class="hds-overlay" *ngIf="isConfirm" (click)="closeConfirm()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="hds-a">
      <span class="hds-ico">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14"/></svg>
      </span>
      <h3>Hapus background ini?</h3>
      <p>Tindakan ini tidak bisa dibatalkan.</p>
      <div class="hds-item">
        <img *ngIf="isConfirm.v.image_url" [src]="isConfirm.v.image_url" alt="" class="hds-thumb">
        {{isConfirm.v.name}}
      </div>
      <div class="hds-warn" *ngIf="isConfirm.v.voucher_count > 0">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round"><path d="M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0zM12 9v4M12 17h.01"/></svg>
        <span>Background ini masih dipakai {{formatNumber(isConfirm.v.voucher_count)}} voucher &mdash;
          sistem akan menolak penghapusan sampai voucher tersebut dihapus atau dipindahkan.</span>
      </div>
    </div>
    <div class="hds-foot hds-foot-full">
      <button type="button" class="vl-btn-ghost" [disabled]="isDeleting" (click)="closeConfirm()">Batal</button>
      <button type="button" class="hds-btn-danger" [disabled]="isDeleting" (click)="confirmDelete()">
        <i class="fa fa-spinner fa-spin" *ngIf="isDeleting"></i> Hapus</button>
    </div>
  </div>
</div>

<!-- full-size image viewer: click anywhere or Escape closes -->
<div class="vb-viewer" *ngIf="isViewer" (click)="closeViewer()">
  <img [src]="isViewer" alt="Background ukuran penuh">
  <button type="button" class="vb-viewer-close" title="Tutup" aria-label="Tutup">&times;</button>
</div>
